// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1370":"312d94d9","4184":"8b199f87"}[chunkId] + ".chunk.css";
};